export const CAMINHO_LISTA = '/projetos';
export const CAMINHO_DETALHE = '/projetos/$projetoId';

export const enderecoDoProjetoDetalhe = (id: string) =>
  ({ to: CAMINHO_DETALHE, params: { projetoId: id } }) as const;

export type StatusDeProjeto =
  | 'DRAFT'
  | 'PLANNING'
  | 'ACTIVE'
  | 'ON_HOLD'
  | 'COMPLETED'
  | 'CANCELLED';

export const SITUACOES_DE_PROJETO: ReadonlyArray<{
  valor: StatusDeProjeto;
  rotulo: string;
  cor: string;
}> = [
  { valor: 'DRAFT', rotulo: 'Rascunho', cor: 'text-muted-foreground' },
  { valor: 'PLANNING', rotulo: 'Planejamento', cor: 'text-blue-600' },
  { valor: 'ACTIVE', rotulo: 'Ativo', cor: 'text-green-600' },
  { valor: 'ON_HOLD', rotulo: 'Suspenso', cor: 'text-yellow-600' },
  { valor: 'COMPLETED', rotulo: 'Concluído', cor: 'text-emerald-600' },
  { valor: 'CANCELLED', rotulo: 'Cancelado', cor: 'text-red-600' },
] as const;

export const situacaoDeProjeto = (valor: StatusDeProjeto) =>
  SITUACOES_DE_PROJETO.find((s) => s.valor === valor) ?? SITUACOES_DE_PROJETO[0]!;
